import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import {
        onMounted,
        onUnmounted,
        computed,
        ComputedRef
    } from 'vue'
    import { 
        QuestionComposable,
        IFeedbackStyling,
        IHeadingStyling
    } from '@/interfaces'
    import playTime from '@/utilities/playTime'
    import resetGame from '@/utilities/resetGame'
    import time from '@/store/time'
    import status from '@/store/status'
    import useQuestion from '@/composables/useQuestion'
    import useWatchers from '@/composables/useWatchers'
    import ChoiceButton from '@/elements/ChoiceButton.vue'
    import FeedbackDetails from '@/elements/FeedbackDetails.vue'
    
    
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

    const {
        question,
        choices,
        answer,
        selection,
        level,
        timerId,
        wasAnswered,
        wasCorrect,
        determineCorrect,
        updateQuestion,
        showAnswer,
        resetQuestion
    }: QuestionComposable = useQuestion()

    const heading: ComputedRef<string> = computed(() => {
        let text: string = ''

        if (status.hasWon) {
            text = 'YOU WIN!'
        } else if (status.hasLost) {
            text = 'YOU LOSE!'
        } else {
            text = 'Question'
        }

        return text
    })
    
    const headingStyling: ComputedRef<IHeadingStyling> = computed(() => {
        const redText: boolean = status.hasLost
        const greenText: boolean = status.hasWon
        const stylingObject: IHeadingStyling = {
            redText,
            greenText
        }

        return stylingObject
    })
    
    const styling: ComputedRef<IFeedbackStyling> = computed(() => {
        const red: boolean = status.hasLost || (time.value === 0 && !wasAnswered.value) || (wasAnswered.value && !wasCorrect.value)
        const green: boolean = status.hasWon || (wasAnswered.value && wasCorrect.value)
        const stylingObject: IFeedbackStyling = {
            red,
            green
        }

        return stylingObject
    })

    onMounted(() => {
        resetGame()
        playTime(timerId, wasAnswered)
    })

    onUnmounted(() => {
        clearInterval(timerId.value)
        setTimeout(resetGame, 1000)
    })

    useWatchers(wasAnswered)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", null, [
    _createElementVNode("h1", {
      class: _normalizeClass(_unref(headingStyling))
    }, _toDisplayString(_unref(heading)), 3),
    _createElementVNode("section", null, [
      _createElementVNode("h2", null, _toDisplayString(_unref(question)), 1),
      _createElementVNode("ol", {
        class: _normalizeClass(_unref(styling))
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(choices), (choice) => {
          return (_openBlock(), _createBlock(ChoiceButton, {
            key: choice,
            choice: choice,
            selection: _unref(selection),
            level: _unref(level),
            "was-answered": _unref(wasAnswered),
            "is-correct": _unref(determineCorrect)(choice),
            onGetFeedback: _unref(showAnswer)
          }, null, 8, ["choice", "selection", "level", "was-answered", "is-correct", "onGetFeedback"]))
        }), 128))
      ], 2),
      (
                    _unref(wasAnswered) || 
                    _unref(time).value === 0 ||
                    _unref(status).hasWon ||
                    _unref(status).hasLost
                )
        ? (_openBlock(), _createBlock(FeedbackDetails, {
            key: 0,
            answer: _unref(answer),
            "was-answered": _unref(wasAnswered),
            "was-correct": _unref(wasCorrect),
            styling: _unref(styling),
            onGetQuestion: _unref(updateQuestion),
            onPlayAgain: _unref(resetQuestion)
          }, null, 8, ["answer", "was-answered", "was-correct", "styling", "onGetQuestion", "onPlayAgain"]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})